module.exports = __webpack_public_path__ + "static/media/DC_F_Timeless_Sforza_IndacoBlue.22381fc0.png";